<template>
  <b-sidebar
    id="add-new-grupousuario-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="showAddUserSidebar($event)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ menus.id_menu === null ? 'Adicionar Nova' : 'Atualizar' }} Fucionalidade
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Titulo Cliente -->
          <validation-provider
            #default="validationContext"
            name="Titulo Menu"
            rules="required"
          >
            <b-form-group
              label="Titulo"
              label-for="titulo-menu"
            >
              <b-form-input
                id="titulo-menu"
                v-model="menus.title"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Descrição Cliente -->
          <validation-provider
            #default="validationContext"
            name="Descrição Menu"
          >
            <b-form-group
              label="Descrição"
              label-for="descricao-menus"
            >
              <b-form-input
                id="descricao-menus"
                v-model="menus.descricao"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Ordem Cliente -->
          <validation-provider
            #default="validationContext"
            name="Ordem Menu"
          >
            <b-form-group
              label="Ordem"
              label-for="order-menus"
            >
              <b-form-input
                id="order-menus"
                v-model="menus.order"
                type="number"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Options Icons Menus -->
          <validation-provider
            #default="validationContext"
            name="icons_menus"
          >
            <b-form-group
              label="Icons"
              label-for="id-icons-menus"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="menus.icon"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionsIcons"
                :reduce="val => val.value"
                :clearable="false"
                input-id="id-icons-menus"
                placeholder="Selecione um Icone"
              >
                <template #option="{ label, value }">
                  <feather-icon
                    :icon="value"
                    size="16"
                    class="align-middle mr-50"
                  />
                  <span> {{ label }}</span>
                </template>
              </v-select>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Childs Menus -->
          <validation-provider
            #default="validationContext"
            name="rotas-menus"
          >
            <b-form-group
              label="Rotas"
              label-for="name-rotas"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="menus.route"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                placeholder="Selecione uma Rota"
                :options="getRoutes"
                :reduce="val => val.value"
                clearable
                input-id="name-rotas"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Childs Menus -->
          <validation-provider
            #default="validationContext"
            name="menu_pai"
          >
            <b-form-group
              label="Sub Cliente"
              label-for="id_parent"
              :state="getValidationState(validationContext)"
            >
              <v-select
                id="id_parent"
                v-model="menus.children"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="title"
                :reduce="menu => menu"
                placeholder="Selecione os sub-menus"

                :options="childsOptionsMenus"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Grupos -->
          <validation-provider
            #default="validationContext"
            name="grupos-menus"
          >
            <b-form-group
              label="Grupos"
              label-for="grupos-menus"
              :state="getValidationState(validationContext)"
            >
              <v-select
                id="grupos-menus"
                v-model="menus.grupos"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                multiple
                label="grupousuario"
                :reduce="grupo => grupo"
                placeholder="Selecione os grupos que terão acesso ao menu"
                :options="gruposOptions"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ menus.id_menu === null ? 'Adicionar' : 'Atualizar' }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>

  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { computed, ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { AllIcons } from './AllIconsTemplate'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-usuarios-sidebar-active',
  },
  props: {
    blankMenusData: {
      type: Object,
      required: true,
    },
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    childsOptionsMenus: {
      type: Array,
      required: true,
    },
    gruposOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  computed: {
    getRoutes() {
      return this.$router.options.routes.map(item => {
        if (item.name !== undefined && item.name.includes('app')) {
          return {
            label: item.path.replace('/', '') === '' ? 'Principal' : item.path.replace('/', ''),
            value: item.name,
          }
        }
      }).filter(item => item !== undefined)
    },
  },
  methods: {
    showAddUserSidebar(e) {
      this.$emit('input', e)
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const optionsIcons = ref(AllIcons)
    const menus = computed({
      get: () => {
        if (props.blankMenusData) {
          return props.blankMenusData
        }
        return JSON.parse(JSON.stringify(props.blankMenusData))
      },
      set: val => {
        emit('update:blankMenusData', val)
      },
    })
    const resetmenus = () => {
      menus.value = JSON.parse(JSON.stringify(menus.value))
    }

    const onSubmit = () => {
      if (menus.value.id_menu === null) {
        if (!menus.value.order) {
          menus.value.order = 0
        }
        store.dispatch('app-adm-menus/addMenu', {
          ...menus.value,
        })
          .then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Fucionalidade adicionado com sucesso!',
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            })
            emit('refetch-data')
            emit('input', false)
          })
          .catch(error => {
            toast({
              component: ToastificationContent,
              props: {
                title: error.response.data.message,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
        return
      }
      store.dispatch('app-adm-menus/updatedMenu', {
        ...menus.value,
      })
        .then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Fucionalidade atualizado com sucesso!',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          emit('refetch-data')
          emit('input', false)
        })
    }

    const {
      fetchGrupos,
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetmenus)

    return {
      optionsIcons,
      fetchGrupos,
      menus,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-grupousuario-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
